<template>
  <v-row>
    <!-- chart -->
    <v-col class="col-12">
      <chartjs-wrapper
        ref="chartJsWrapper"
        class="white"
        chartId="earlyBookingChart"
        :chart-data="earlyBookingChartData"
        :type="'line'"
        :options="earlyBookingChartOptions"
        :chart-height="20"
        hover-line
        @click:element="clickedChartPoint"
      >
      </chartjs-wrapper>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DateRangeChartMixin from '@/components-internal/mixins/DateRangeChartMixin'
import _ from 'lodash'
import definitions from '../../../definitions'

export default Vue.extend({
  name: 'EarlyBookingChart',

  mixins: [DateRangeChartMixin],

  props: {
    maximumEarlyBookingDiscounts: {
      type: Array,
      required: true,
    },
  },

  computed: {
    earlyBookingChartData() {
      let data = {
        labels: [],
        datasets: [],
      }

      let linesData = _.groupBy(
        this.maximumEarlyBookingDiscounts,
        'productDefinitionId'
      )
      let colors = [...definitions.colors.lineChart]
      let color = definitions.colors.named.red
      let colorPostedPrice = definitions.colors.named.minPrice

      for (let productDefinitionId in linesData) {
        let discountLine = {
          lineTension: 0,
          yAxisID: 'FactorAxis',
          data: [],
          label: this.$i18n.t('maxEarlyBookingChart.factorAxis'),
          pointRadius: [],
          borderWidth: definitions.globalChartSettings.borderWidth,
          pointBackgroundColor: [],
          pointBorderColor: [],
          borderColor: color,
          backgroundColor: 'rgba(218,37,75,0.1)',
          fill: true,
        }
        let currentPostedPriceLine = {
          lineTension: 0,
          yAxisID: 'PostedPriceAxis',
          data: [],
          label: this.$i18n.t('maxEarlyBookingChart.priceAxis'),
          pointRadius: [],
          borderWidth: definitions.globalChartSettings.borderWidth,
          pointBackgroundColor: [],
          pointBorderColor: [],
          borderColor: colorPostedPrice,
          backgroundColor: 'rgba(38,153,214,0.1)',
          fill: true,
        }

        linesData[productDefinitionId].forEach((maxEarlyBookingDiscount) => {
          discountLine.data.push(
            maxEarlyBookingDiscount.getCurrentEarlyBookingDiscount()
          )
          currentPostedPriceLine.data.push(
            maxEarlyBookingDiscount.getChartFormattedPostedPrice()
          )

          if (maxEarlyBookingDiscount.hasCustomEarlyBookingDiscount()) {
            discountLine.pointBackgroundColor.push(
              definitions.colors.named.minPrice
            )
            discountLine.pointBorderColor.push(
              definitions.colors.named.minPrice
            )
            discountLine.pointRadius.push(
              definitions.globalChartSettings.pointRadius
            )
          } else {
            discountLine.pointBackgroundColor.push('white')
            discountLine.pointBorderColor.push(color)
            discountLine.pointRadius.push(0)
          }

          if (maxEarlyBookingDiscount.hasCustomPostedPrice()) {
            currentPostedPriceLine.pointBackgroundColor.push(
              definitions.colors.named.overwritten
            )
            currentPostedPriceLine.pointBorderColor.push(
              definitions.colors.named.overwritten
            )
            currentPostedPriceLine.pointRadius.push(
              definitions.globalChartSettings.pointRadius
            )
          } else {
            currentPostedPriceLine.pointBackgroundColor.push('white')
            currentPostedPriceLine.pointBorderColor.push(colorPostedPrice)
            currentPostedPriceLine.pointRadius.push(0)
          }

          if (data.labels.length <= linesData[productDefinitionId].length) {
            data.labels.push(maxEarlyBookingDiscount.date)
          }
        })
        data.datasets.push(discountLine)
        data.datasets.push(currentPostedPriceLine)
        color = colors.pop()
        colorPostedPrice = colors.pop()
      }

      return data
    },
    earlyBookingChartOptions() {
      const mainOptions = {
        tooltips: {
          callbacks: {
            label: (tooltipItems, data) => {
              if (tooltipItems.datasetIndex === 0) {
                return (
                  data.datasets[tooltipItems.datasetIndex].label +
                  ': ' +
                  tooltipItems.yLabel.toFixed(2)
                )
              } else if (tooltipItems.datasetIndex === 1) {
                return (
                  data.datasets[tooltipItems.datasetIndex].label +
                  ': ' +
                  tooltipItems.yLabel +
                  ` ${store.getters
                    .getCurrentDestinationInstance()
                    .getCurrency()}`
                )
              }
            },
          },
        },
        scales: {
          yAxes: [
            {
              id: 'PostedPriceAxis',
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: this.$t('maxEarlyBookingChart.ylabel'),
              },
              ticks: {
                fontColor: definitions.colors.named.minPrice,
              },
            },
            {
              id: 'FactorAxis',
              position: 'right',
              gridLines: {
                drawOnChartArea: false,
              },
              ticks: {
                // beginAtZero: true,
                // min: 0,
                // suggestedMax: 1,
                fontColor: definitions.colors.named.red,
              },
            },
          ],
          xAxes: [
            {
              min: this.dateRange.startDate,
              max: this.dateRange.endDate,
              unit: this.unit,
              stepSize: 1,
            },
          ],
        },
      }
      return _.merge(this.baseChartOptions, mainOptions)
    },
  },
})
</script>
